import { h, render, createContext } from "preact";
import { useState, useEffect } from "preact/hooks";

const AppContext = createContext([{}, () => { }]);

const AppProvider = (props) => {
	//console.log("AppProvider", props)

	return <AppContext.Provider value={props.value}>{props.children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
